<template>
    <div v-if="user">
        <va-page-header>

            <div slot="title">
                <va-button class="back_button" @click.native="$router.go(-1)" type="default" size="lg">
                    <va-icon type="chevron-left"></va-icon>
                </va-button>
                {{_('Department')}}
            </div>

            <div slot="actions" style="display: flex; flex-direction: row; align-items:  center">
                <va-button v-if="!viewedDepartment && user.get('roles').includes('admin')" type="primary"
                    @click.native="createDepartment" size="lg" style="margin-right:10px">{{
                        _('CREATE') }}
                </va-button>
                <va-button
                    v-else-if="viewedDepartment && (user.get('roles').includes('admin') || user.get('roles').includes('manager'))"
                    type="primary" @click.native="saveChanges" size="lg" style="margin-right:10px">
                    {{ _('UPDATE') }}
                </va-button>
            </div>

        </va-page-header>

        <va-form type="vertical" ref="form">
            <va-row :gutter="12" style="margin-bottom: 20px">
                <va-column :lg="3" :md="3" :sm="12" :xs="12">

                    <span class="field_label">{{ _('English name') }}</span>
                    <va-input :disabled="user.type == 'user' || user.type == 'guest'" v-model="departmentName" showClean
                        name="name" :placeholder="_('English name')" :rules="[{type:'required'}]" />

                </va-column>
                <va-column :lg="3" :md="3" :sm="12" :xs="12">

                    <span class="field_label">{{ _('Pashto name') }}</span>
                    <va-input :disabled="user.type == 'user' || user.type == 'guest'" v-model="departmentNamePashto"
                        showClean name="name" :placeholder="_('Pashto name')" />

                </va-column>
                <va-column :lg="3" :md="3" :sm="12" :xs="12">

                    <span class="field_label">{{ _('Dari name') }}</span>
                    <va-input :disabled="user.type == 'user' || user.type == 'guest'" v-model="departmentNameDari"
                        showClean name="name" :placeholder="_('Dari name')" />

                </va-column>
            </va-row>

            <va-row :gutter="12" v-if="viewedDepartment">
                <va-column :lg="6" :sm="12" :md="6" :xs="12">
                    <span class="field_label">{{ _('Managers') }}</span>
                    <va-card :elevation="2" :padding="10" v-for="manager in departmentManagers"
                        style="padding: 10px; position: relative; max-width: 400px; margin: 5px "
                        v-if="departmentManagers.length != 0">

                        <img width="45px" height="45px" style="margin: 0 10px; border-radius: 100px;"
                            :src="manager.get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')">
                        <span style="position: absolute; top: 15%;">{{manager.get('name')}}</span>
                        <span style="position: absolute; top: 45%; color: gray">{{manager.get('username')}}</span>

                    </va-card>

                    <va-lozenge v-if="departmentManagers.length == 0" type="danger" bold>{{ _('No Managers') }}
                    </va-lozenge>
                </va-column>

                <va-column :lg="6" :sm="12" :md="6" :xs="12">
                    <span class="field_label">{{ _('Users') }}</span>
                    <va-card :elevation="2" :padding="10" v-for="user in departmentUsers"
                        style="padding: 10px; position: relative; max-width: 400px; margin: 5px 0"
                        v-if="departmentUsers.length != 0">

                        <img width="45px" height="45px" style="margin: 0 10px; border-radius: 100px;"
                            :src="user.get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')">
                        <span style="position: absolute; top: 15%;">{{user.get('name')}}</span>
                        <span style="position: absolute; top: 45%; color: gray">{{user.get('username')}}</span>

                    </va-card>
                    <va-lozenge v-if="departmentUsers.length == 0" type="danger" bold>{{ _('No Users') }}</va-lozenge>
                </va-column>
            </va-row>
            <hr>
            <br>

            <activities v-if="viewedDepartment && user.get('type') != 'guest'" />
        </va-form>
    </div>

</template>

<script>
import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";
    import UserSelection from './UserSelection.vue'
    import MyTypeahead from '@/components/MyTypeahead.vue';
    import Activities from './Activities'


    export default {

        components: {
            MyTypeahead,
            Activities
        },

        data() {
            return {
                departmentName: '',
                departmentNamePashto: '',
                departmentNameDari: '',
                selectedManager: null,

                users: [],
                usernameOrEmail: '',

                viewedDepartment: null,
                departmentUsers: [],
                departmentManagers: [],
            };
        },

        computed: {
            ...mapGetters(["user"]),


        },

        methods: {



            selectedUser(user) {
                this.usernameOrEmail = ''
                this.selectedManager = user
            },

            async createDepartment() {
                this.$refs.form.validateFields(async result => {
                    if (result.isvalid) {
                        if (this.departmentName == 'admin' || this.departmentName == 'manager' || this.departmentName == 'guest' || this.departmentName == 'survey' || this.departmentName == 'article' || this.departmentName == 'file' || this.departmentName == 'map') {
                            this.$notify({
                                group: 'foo',
                                text: this._('Please pick another name, this word is reserved'),
                                duration: 4000,
                                position: 'top left',
                                type: 'warn'
                            })
                            return false
                        }
                        this.$store.commit('setLoading', true)
                        let q = new Parse.Query('Department')
                        q.equalTo('slug', this.departmentName.slugify())
                        let result = await q.first()
                        if (!result) {
                            // creating role for the department, then the department users will be assigned this role
                            var roleACL = new Parse.ACL();
                            roleACL.setPublicReadAccess(true);
                            roleACL.setRoleWriteAccess("admin", true)
                            roleACL.setRoleWriteAccess("manager", true)
                            var role = new Parse.Role(this.departmentName.slugify(), roleACL);
                            await role.save().then(async role_result => {
                                let DeptClass = Parse.Object.extend('Department')
                                let newDept = new DeptClass()
                                newDept.save({
                                    label_english: this.departmentName,
                                    label_pashto: this.departmentNamePashto,
                                    label_dari: this.departmentNameDari,
                                    slug: this.departmentName.slugify(),
                                    createdBy: makePointer('User', this.user.id),
                                }).then(async res => {
                                    await this.g_newActivity({
                                        label_english: res.get('label_english'),
                                        label_pashto: res.get('label_pashto'),
                                        label_dari: res.get('label_dari'),
                                        type: 'department',
                                        action: 'create',
                                        url: this.$route.path.slice(0, -3) + res.id,
                                        createdBy: this.user.id,
                                        to: null,
                                        category: null,
                                        department: res,
                                        class: 'Department',
                                        reference_id: res.id

                                    })
                                    this.$router.go(-1)
                                    this.$store.commit('setLoading', false)
                                    this.$notify({
                                        group: 'foo',
                                        text: this._('Department was created'),
                                        duration: 4000,
                                        position: 'top left',
                                        type: 'success'
                                    });

                                }).catch(e => {
                                    this.$store.commit('setLoading', false)
                                    this.$notify({
                                        group: 'foo',
                                        text: this._('An error accured while creating department'),
                                        duration: 4000,
                                        position: 'top left',
                                        type: 'error'
                                    });

                                })
                            }).catch(e => {
                                this.$store.commit('setLoading', false)
                                this.$notify({
                                    group: 'foo',
                                    title: this._('System Error'),
                                    text: this._(e.toString()),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            })
                        } else {
                            this.$store.commit('setLoading', false)
                            this.$notify({
                                group: 'foo',
                                text: this._('Department already exists'),
                                duration: 4000,
                                position: 'top left',
                                type: 'error'
                            });
                        }
                    }
                })
            },

            async saveChanges() {
                this.$refs.form.validateFields(async result => {
                    if (result.isvalid) {
                        this.viewedDepartment.set('label_english', this.departmentName)
                        this.viewedDepartment.set('label_pashto', this.departmentNamePashto)
                        this.viewedDepartment.set('label_dari', this.departmentNameDari)
                        await this.viewedDepartment.save()
                            .then(async updated => {
                                await this.g_newActivity({
                                    label_english: updated.get('label_english'),
                                    label_pashto: updated.get('label_pashto'),
                                    label_dari: updated.get('label_dari'),
                                    type: 'department',
                                    action: 'edit',
                                    url: this.$route.path,
                                    createdBy: this.user.id,
                                    to: null,
                                    category: null,
                                    department: updated,
                                    class: 'Department',
                                    reference_id: updated.id
                                })
                                this.$notify({
                                    group: 'foo',
                                    text: this._('Department was updated'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'success'
                                });
                            }).catch(e => {
                                this.$notify({
                                    group: 'foo',
                                    text: this._('An error accured while updating department'),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'error'
                                });
                            })
                    }
                })
            },

            async fetchUsers() {
                let q = new Parse.Query('User')
                q.equalTo('departments', this.viewedDepartment)
                q.equalTo('type', 'user')
                this.departmentUsers = await q.find()
            },

            async fetchManagers() {
                let q = new Parse.Query('User')
                q.equalTo('departments', this.viewedDepartment)
                q.equalTo('type', 'manager')
                this.departmentManagers = await q.find()
            },

        },

        async mounted() {
            this.$store.commit("setLoading", true);
            if (this.$route.params.id !== 'new') {
                this.viewedDepartment = await this.g_fetchObject(this.$route.params.id, 'Department')
                this.departmentName = this.viewedDepartment.get('label_english')
                this.departmentNamePashto = this.viewedDepartment.get('label_pashto')
                this.departmentNameDari = this.viewedDepartment.get('label_dari')
                await this.fetchManagers()
                await this.fetchUsers()
            }
            this.$store.commit("setLoading", false);
        }
    };
</script>

<style>
    .members_list .va-form-group {
        margin-top: -5px;
        margin-bottom: -5px
    }
</style>